module.exports = __webpack_public_path__ + "static/media/a.a4f4eb12.jpg";